module.exports = __webpack_public_path__ + "97f06bb30d137ea3f2670ebcaf2c302f.jpg";